export var config = {
    sgkey: "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",
    googleapi : "AIzaSyCamnPcSMxBtmOEhLZ6YYafn5f_DSNC8Hs",
    trudesk_key_dev : "b71afdd1dcb25821557c5b73819c3ffef2b768b6",
    trudesk_key : "b71afdd1dcb25821557c5b73819c3ffef2b768b6",
    // serverUrl : "https://charusat.admissiondesk.org:3000",
    serverUrl : "https://admission.sdbi.in/UIServer",
    clientUrl : 'https://admission.sdbi.in/app/#/pages/',
    preServerUrl : "https://preadmissions.sdbi.in/api",
  }